import { type FC } from 'react'

import { useVisibleState } from '@foxino/components-common'

import { useUserProfile } from '../../data/useUserProfile'
import type { SettingsSection } from '../../model/enums'
import { SmallProfileDialog } from './components/SmallProfileDialog'
import { MainSettingsDialog } from './components'

type Props = {
  onClose: () => void
}

export const SettingsDialog: FC<Props> = ({ onClose }) => {
  const [isBigDialogOpen, showBigDialog, , dialogSection] = useVisibleState<SettingsSection>(false)

  const { data, actions, isPending } = useUserProfile()

  if (!data) {
    return null
  }

  return (
    <>
      {!isBigDialogOpen ? (
        <SmallProfileDialog userProfile={data} onClose={onClose} onSettingsOpen={showBigDialog} />
      ) : (
        <MainSettingsDialog
          userActions={actions}
          onClose={onClose}
          userProfile={data}
          dialogSection={dialogSection}
          isPending={isPending}
        />
      )}
    </>
  )
}
